// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorSharedGlobalIdUpsearchModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorSharedGlobalIdUpsearchModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorSharedGlobalIdUpsearchModel.discriminator = undefined;
EnterpriseCoordinatorSharedGlobalIdUpsearchModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "globalIdTypeCode",
        "baseName": "globalIdTypeCode",
        "type": "string"
    },
    {
        "name": "globalId",
        "baseName": "globalId",
        "type": "string"
    }
];
//# sourceMappingURL=enterpriseCoordinatorSharedGlobalIdUpsearchModel.js.map